import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export function PaymentMethodSelect({
    methods,
    value,
    onChange,
    label = 'Payment method used',
    noneLabel,
    showNoneOption = true
}) {
    const labelId = 'fill-select-label';
    const hasMethods = (methods || []).length > 0;
    const noneOptionLabel = noneLabel || 'Original payment method';

    console.log({ methods, value });
    return (
        <FormControl fullWidth variant="outlined" margin="dense">
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
                id="fill-select"
                labelId={labelId}
                value={value?.slug || 'none'}
                onChange={e => onChange(String(e.target.value))}
                label={label}
                disabled={!hasMethods}
            >
                {showNoneOption && (
                    <MenuItem key="none" value="none">
                        {noneOptionLabel}
                    </MenuItem>
                )}
                {methods.map(m => (
                    <MenuItem key={m.slug} value={m.slug}>
                        {`${m.name}`}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
